import { render, staticRenderFns } from "./DigitalBooks.vue?vue&type=template&id=28bf0f29&"
import script from "./DigitalBooks.vue?vue&type=script&lang=js&"
export * from "./DigitalBooks.vue?vue&type=script&lang=js&"
import style0 from "./DigitalBooks.vue?vue&type=style&index=0&id=28bf0f29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports